module.exports = "/_next/static/media/66df897f7e2455ad2be4396bdf1d3e3f.svg";